module.exports = __webpack_public_path__ + "img/gt-radial.b313f9e0.svg";